export function formatTimeInSast(dateTimeValue, sourceOffset) {
  if (!dateTimeValue || typeof sourceOffset !== "number") {
    return "";
  }

  const [datePart, timePart] = dateTimeValue.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(":").map(Number);
  const sourceUtcTime = Date.UTC(year, month - 1, day, hour - sourceOffset, minute);
  const sastDate = new Date(sourceUtcTime + 2 * 60 * 60 * 1000);

  return new Intl.DateTimeFormat("en-ZA", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC"
  }).format(sastDate);
}
